export default "__VITE_ASSET__SHTWqYC5__"